import { Capacitor } from "@capacitor/core"
import { Keyboard } from "@capacitor/keyboard"

const KEYBOARD_VISIBLE_CLASS = "keyboard-visible"

class KeyboardService {
    private initialized = false

    async initialize() {
        if (this.initialized || !Capacitor.isNativePlatform()) {
            return
        }
        this.initialized = true

        Keyboard.addListener("keyboardWillShow", () => {
            document.body.classList.add(KEYBOARD_VISIBLE_CLASS)
        })
        Keyboard.addListener("keyboardDidHide", () => {
            document.body.classList.remove(KEYBOARD_VISIBLE_CLASS)
        })
    }
}

export const KeyboardConfig = new KeyboardService()
